import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c69f936"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "million-users16167-testimonial__header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "million-users16167-testimonial__name" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "million-users16167-testimonial__body" }
const _hoisted_6 = { class: "million-users16167-testimonial__text" }


export default /*#__PURE__*/_defineComponent({
  __name: 'MillionUsers16167Testimonial',
  props: {
    person: null,
    image: null,
    isActive: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["million-users16167-testimonial", { 'million-users16167-testimonial--active': __props.isActive }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: __props.image,
        alt: "",
        width: "90",
        height: "90",
        class: "million-users16167-testimonial__image"
      }, null, 8, _hoisted_2),
      _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.person.name), 1),
      _createElementVNode("p", {
        class: "million-users16167-testimonial__subtitle",
        innerHTML: __props.person.subtitle
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString(__props.person.text), 1)
    ])
  ], 2))
}
}

})